import { useCallback, useState } from 'react';

import { InboxEntry, InboxEntryCollectionMutations } from '@this+that/models';
import log from 'loglevel';

import { useUpdateInboxEntryCollections as useUpdateInboxEntryCollectionsService } from '../../services/inboxEntries.service';

export const useUpdateInboxEntryCollections = () => {
  const {
    updateInboxEntryCollections: updateInboxEntryCollectionsService,
    loading,
    error,
  } = useUpdateInboxEntryCollectionsService();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateInboxEntryCollections = useCallback(
    async (
      inboxEntryId: string,
      collections: InboxEntryCollectionMutations,
    ): Promise<InboxEntry | null | undefined> => {
      setIsUpdating(true);
      try {
        const updatedEntry = await updateInboxEntryCollectionsService(
          inboxEntryId,
          collections,
        );
        return updatedEntry;
      } catch (error) {
        log.error('Error updating inbox entry:', error);
        throw error;
      } finally {
        setIsUpdating(false);
      }
    },
    [updateInboxEntryCollectionsService],
  );

  return {
    handleUpdateInboxEntryCollections,
    loading: loading || isUpdating,
    error,
  };
};
